var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 2.82l7.83 7.84L0 18.5l2.82 2.82 7.84-7.83 7.84 7.83 2.82-2.82-7.83-7.84 7.83-7.84L18.5 0l-7.84 7.83L2.82 0z","fill":"#fff"}));
}

Close.defaultProps = {"viewBox":"0 0 21.32 21.32"};

module.exports = Close;

Close.default = Close;
